/* This file is generated automatically by 'django-admin create_groups --frontend' command */

export const USER_GROUP = {
  REGISTRAR: "registrar",
  TRANSACTION_REPORT: "transaction_report",
  INTELLIGENCE_REPORT: "intelligence_report",
  CONVERSION_REPORT: "conversion_report",
  VIEW_PREDICTOR_REPORT: "view_predictor_report",
  EDIT_PREDICTOR_REPORT: "edit_predictor_report",
  VIEW_TRADE_SHOW_STUDENT_PROFILE_DUPLICATE: "view_trade_show_student_profile_duplicate",
  VIEW_EMAIL_TRACKING_REPORT: "view_email_tracking_report",
  VIEW_STUDENT_STATUS_CONVERSION_REPORT: "view_student_status_conversion_report",
  INTERVIEW: "interview",
  INTERVIEWER: "interviewer",
  INTERVIEWER_AVAILABILITY: "interviewer_availability",
  ASSIGNED_PROFILE: "assigned_profile",
  TRANSFER_INTERVIEW: "transfer_interview",
  ASSIGN_INTERVIEWER: "assign_interviewer",
  INTERVIEW_BOOKING: "interview_booking",
  INTERVIEW_SCHEDULE: "interview_schedule",
  INTERVIEW_SETTINGS: "interview_settings",
  INTERVIEW_QUESTION: "interview_question",
  SEND_SMS: "send_sms",
  VIEW_SMS: "view_sms",
  VIEW_SMS_TEMPLATES: "view_sms_templates",
  EDIT_SMS_TEMPLATE: "edit_sms_template",
  EDIT_SMS_SETTINGS: "edit_sms_settings",
  EDIT_EVENTS_SETTINGS: "edit_events_settings",
  VIEW_EVENTS: "view_events",
  EDIT_EVENT: "edit_event",
  VIEW_FOLLOWUPS: "view_followups",
  EDIT_FOLLOWUPS: "edit_followups",
  VIEW_EMAIL_PREFERENCES: "view_email_preferences",
  EDIT_EMAIL_PREFERENCES: "edit_email_preferences",
  VIEW_ADDRESS_BOOK: "view_address_book",
  EDIT_ADDRESS_BOOK: "edit_address_book",
  VIEW_TEMPLATE_SELECTORS: "view_template_selector",
  EDIT_TEMPLATE_SELECTORS: "edit_template_selector",
  VIEW_EMAIL_SIGNATURES: "view_email_signatures",
  EDIT_EMAIL_SIGNATURES: "edit_email_signatures",
  VIEW_EMAIL_TEMPLATES: "view_email_templates",
  EDIT_EMAIL_TEMPLATES: "edit_email_templates",
  EDIT_STUDENT_PROFILE: "edit_student_profile",
  EDIT_SAML_SETTINGS: "edit_saml_settings",
  VIEW_ROLES: "view_roles",
  EDIT_ROLES: "edit_roles",
  VIEW_STAFF: "view_staff",
  EDIT_STAFF: "edit_staff",
  VIEW_VOLUNTEERS: "view_volunteers",
  EDIT_VOLUNTEERS: "edit_volunteers",
  EDIT_EXTERNAL_ID: "edit_external_id",
  EDIT_IS_HOW_HEAR_MULTIPLE_CHOICE: "edit_is_how_hear_multiple_choice",
};

export const GROUP_LABEL_MAP = {
  registrar: "Registrar",
  transaction_report: "Transaction",
  intelligence_report: "Intelligence",
  conversion_report: "Conversion",
  view_predictor_report: "View predictor report settings / generate predictor report",
  edit_predictor_report: "Edit predictor report settings",
  view_trade_show_student_profile_duplicate: "View register interest duplicates",
  view_email_tracking_report: "View email tracking report",
  view_student_status_conversion_report: "View student status conversion report",
  interview:
    "Assign/unassign interviewer, complete/delete interview, upload review PDF scan",
  interviewer: "View/add/edit/delete interviewers",
  interviewer_availability: "View/add/edit/delete/split availability",
  assigned_profile: "View assigned profiles",
  transfer_interview: "Transfer interview",
  assign_interviewer: "Assign/unassign interviewer",
  interview_booking: "Book interview, cancel booking",
  interview_schedule: "View/print/export interview schedule",
  interview_settings: "Edit interview settings",
  interview_question: "View/add/edit/delete interview questions",
  send_sms: "Send SMS, change automation SMS template",
  view_sms: "View SMS",
  view_sms_templates: "View SMS templates",
  edit_sms_template: "Add/edit SMS templates",
  edit_sms_settings: "Edit SMS settings",
  edit_events_settings: "Edit events settings",
  view_events: "View events",
  edit_event: "Add/edit/delete event",
  view_followups: "View automations",
  edit_followups: "Add/edit/delete automations",
  view_email_preferences: "View email preferences",
  edit_email_preferences: "Add/edit/delete email preferences",
  view_address_book: "View address book",
  edit_address_book: "Add/edit/delete address book",
  view_template_selector: "View template selectors",
  edit_template_selector: "Add/edit/delete template selectors",
  view_email_signatures: "View email signatures",
  edit_email_signatures: "Add/edit email signatures",
  view_email_templates: "View email templates",
  edit_email_templates: "Add/edit/delete email templates",
  edit_student_profile: "View/edit application",
  edit_saml_settings: "Edit SAML settings",
  view_roles: "View roles",
  edit_roles: "Edit roles",
  view_staff: "View staff users",
  edit_staff: "Add/edit staff users",
  view_volunteers: "View volunteers",
  edit_volunteers: "Add/edit volunteers",
  edit_external_id: "Edit external ID",
  edit_is_how_hear_multiple_choice: "Edit 'How Hear' field's ability to be multiple",
};

export const ROLES = {
  Interviewer: "Interviewer",
  Finance: "Finance",
  Developer: "Developer",
  Admin: "Admin",
  Registrar: "Registrar",
};

export const GROUP_GROUPING = [
  {
    name: "Legacy",
    groups: ["registrar"],
  },
  {
    name: "Interview",
    groups: [
      "interview",
      "interviewer",
      "interviewer_availability",
      "assigned_profile",
      "assign_interviewer",
      "transfer_interview",
      "interview_booking",
      "interview_schedule",
      "interview_settings",
      "interview_question",
    ],
  },
  {
    name: "Reports",
    groups: [
      "transaction_report",
      "intelligence_report",
      "conversion_report",
      "view_student_status_conversion_report",
      "view_predictor_report",
      "edit_predictor_report",
      "view_trade_show_student_profile_duplicate",
      "view_email_tracking_report",
    ],
  },
  {
    name: "SMS",
    groups: [
      "send_sms",
      "view_sms",
      "view_sms_templates",
      "edit_sms_template",
      "edit_sms_settings",
    ],
  },
  {
    name: "Events",
    groups: ["edit_events_settings", "view_events", "edit_event"],
  },
  {
    name: "Automations",
    groups: ["view_followups", "edit_followups"],
  },
  {
    name: "Email",
    groups: [
      "view_email_templates",
      "edit_email_templates",
      "view_email_signatures",
      "edit_email_signatures",
      "view_email_preferences",
      "edit_email_preferences",
      "view_template_selector",
      "edit_template_selector",
      "view_address_book",
      "edit_address_book",
    ],
  },
  {
    name: "Application",
    groups: ["edit_student_profile"],
  },
  {
    name: "User Management",
    groups: [
      "edit_saml_settings",
      "view_roles",
      "edit_roles",
      "view_staff",
      "edit_staff",
      "view_volunteers",
      "edit_volunteers",
    ],
  },
  {
    name: "Fields",
    groups: ["edit_external_id", "edit_is_how_hear_multiple_choice"],
  },
];
